/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useContext } from "react";
import {
  Button,
  ButtonGroup,
  Card,
  Badge,
  InputGroup,
  Spinner,
  Pagination,
  Alert,
} from "@themesberg/react-bootstrap";
import { useState } from "react";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { postApi } from "../../../redux/api";
import CustomTable from "../../../components/CustomTable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEye,
  faPlus,
  faSearch,
  faFilter,
  faSync,
  faCalendarAlt,
  faFileAlt,
  faMoneyBillWave,
  faCheckCircle,
  faClock,
  faExclamationTriangle,
  faLandmark,
} from "@fortawesome/free-solid-svg-icons";
import { Routes } from "../../../routes";
import { formatNumber } from "../../../redux/utils";
import { useSelector } from "react-redux";
import { SearchContext } from "../../HomePage";
import { Col, Form as BootstrapForm, Row } from "react-bootstrap";
import moment from "moment";

function MdaNewPV() {
  const history = useNavigate();
  const user = useSelector((state) => state.auth.user);

  const [filterText, setFilterText] = useState("");
  const [pvList, setPvList] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const today = moment().format("YYYY-MM-DD");
  const aMonthAgo = moment(today).subtract(1, "month").format("YYYY-MM-DD");

  const [statusFilter, setStatusFilter] = useState("All");
  const [dateFrom, setDateFrom] = useState(aMonthAgo);
  const [dateTo, setDateTo] = useState(today);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);

  const { searchTerm, setSearchTerm } = useContext(SearchContext);

  const fetchPvList = useCallback(async () => {
    try {
      setLoading(true);
      setError("");

      const statuses = [
        // "Pending",
        // "Created",
        // "Checked",
        // "Reviewed",
        // "Approved",
        // "Pending - Returned",
        // "Checked - Returned",
        // "Reviewed - Returned",
        // "Approved - Returned",
        "MDA Pending",
        "MDA Checked",
        "MDA Reviewed",
        "MDA Approved",
        "MDA Pending - Returned",
        "MDA Checked - Returned",
        "MDA Reviewed - Returned",
        "MDA Approved - Returned",
      ];
      const allPvs = [];

      for (const status of statuses) {
        try {
          const response = await postApi(`get_pv_collection`, {
            form: {
              query_type: "single_pv_by_mda",
              pv_status: status,
              mda_name: user?.mda_name,
              mda_code: user?.mda_code || "",
              mda_type: "self-sustaining",
            },
          });

          if (response?.result?.length) {
            allPvs.push(...response.result);
          }
        } catch (statusError) {
          console.warn(
            `Failed to fetch PVs with status ${status}:`,
            statusError
          );
        }
      }

      if (allPvs.length > 0) {
        const uniquePvs = allPvs.reduce((acc, current) => {
          const existing = acc.find(
            (item) => item.pv_code === current.pv_code
          );
          if (!existing) {
            acc.push({
              ...current,
              formatted_date: moment(current.date).format("DD/MM/YYYY"),
              formatted_amount: formatNumber(current.amount),
            });
          }
          return acc;
        }, []);

        uniquePvs.sort(
          (a, b) => moment(b.date).valueOf() - moment(a.date).valueOf()
        );

        setPvList(uniquePvs);
      } else {
        setPvList([]);
      }
    } catch (err) {
      console.error("Error fetching MDA PV list:", err);
      setError("Failed to load MDA PV data. Please try again.");
      setPvList([]);
    } finally {
      setLoading(false);
    }
  }, [user?.mda_name, user?.mda_code]);

  const applyFilters = useCallback(() => {
    let filtered = [...pvList];

    if (filterText.trim()) {
      const searchLower = filterText.toLowerCase();
      filtered = filtered.filter(
        (item) =>
          item.pv_code?.toLowerCase().includes(searchLower) ||
          item.approval_no?.toLowerCase().includes(searchLower) ||
          item.mda_name?.toLowerCase().includes(searchLower) ||
          item.narration?.toLowerCase().includes(searchLower)
      );
    }

    if (searchTerm.trim()) {
      const globalSearchLower = searchTerm.toLowerCase();
      filtered = filtered.filter(
        (item) =>
          item.pv_code?.toLowerCase().includes(globalSearchLower) ||
          item.approval_no?.toLowerCase().includes(globalSearchLower) ||
          item.mda_name?.toLowerCase().includes(globalSearchLower)
      );
    }

    if (statusFilter !== "All") {
      filtered = filtered.filter((item) =>
        item.status?.toLowerCase().includes(statusFilter.toLowerCase())
      );
    }

    if (dateFrom) {
      filtered = filtered.filter((item) =>
        moment(item.date).isSameOrAfter(moment(dateFrom), "day")
      );
    }

    if (dateTo) {
      filtered = filtered.filter((item) =>
        moment(item.date).isSameOrBefore(moment(dateTo), "day")
      );
    }

    setFilteredData(filtered);
    setCurrentPage(1);
  }, [pvList, filterText, searchTerm, statusFilter, dateFrom, dateTo]);

  const clearFilters = () => {
    setFilterText("");
    setStatusFilter("All");
    setDateFrom("");
    setDateTo("");
  };

  const refreshData = () => {
    fetchPvList();
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const getUniqueStatuses = () => {
    const statuses = pvList.map((item) => item.status).filter(Boolean);
    return [...new Set(statuses)];
  };

  useEffect(() => {
    if (user?.mda_name) {
      fetchPvList();
    }
  }, [user, fetchPvList]);

  useEffect(() => {
    applyFilters();
  }, [applyFilters]);

  useEffect(() => {
    return () => {
      setSearchTerm("");
    };
  }, [setSearchTerm]);

  const fields = [
    {
      title: "Action",
      custom: true,
      component: (item) => (
        <ButtonGroup size="sm">
          <Button
            variant="outline-primary"
            onClick={() =>
              history(
                `${Routes.pv.viewPvGenerated}?approval_no=${encodeURIComponent(item.approval_no || "")}&approval_type=${encodeURIComponent(item.approval_type || "")}&pv_code=${encodeURIComponent(item.pv_code || "")}&mda_type=self-sustaining`
              )
            }
          >
            <FontAwesomeIcon icon={faEye} className="me-1" />
            View
          </Button>
          {(item.status?.includes("Return") || item.status?.includes("Pending")) && (
            <Button
              variant="outline-secondary"
              onClick={() =>
                history(
                  `${Routes.mdaPv.index}?pv_code=${encodeURIComponent(item.pv_code || "")}&mda_type=self-sustaining`
                )
              }
            >
              <FontAwesomeIcon icon={faPlus} className="me-1" />
              Edit
            </Button>
          )}
        </ButtonGroup>
      ),
    },
    {
      title: "PV Code",
      value: "pv_code",
      sortable: true,
    },
    {
      title: "Approval No.",
      value: "approval_no",
      sortable: true,
    },
    {
      title: "Status",
      custom: true,
      component: (item) => {
        const status = item.status;
        let variant = "secondary";
        let icon = faClock;

        if (status?.includes("Pending")) {
          variant = "info";
          icon = faClock;
        } else if (status?.includes("Return")) {
          variant = "warning";
          icon = faExclamationTriangle;
        } else if (status?.includes("Approved")) {
          variant = "success";
          icon = faCheckCircle;
        } else if (status?.includes("Reviewed")) {
          variant = "primary";
          icon = faCheckCircle;
        } else if (status?.includes("Checked")) {
          variant = "info";
          icon = faCheckCircle;
        }

        return (
          <Badge bg={variant}>
            <FontAwesomeIcon icon={icon} className="me-1" />
            {status}
          </Badge>
        );
      },
    },
    {
      title: "Date",
      custom: true,
      component: (item) => (
        <div>
          <FontAwesomeIcon icon={faCalendarAlt} className="me-1 text-muted" />
          {item.formatted_date}
        </div>
      ),
      sortable: true,
    },
    {
      title: "Amount (₦)",
      custom: true,
      component: (item) => (
        <div className="text-end">
          <FontAwesomeIcon
            icon={faMoneyBillWave}
            className="me-1 text-success"
          />
          {item.formatted_amount}
        </div>
      ),
      sortable: true,
    },
  ];

  return (
    <>
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-md-0">
          <h4>
            <FontAwesomeIcon icon={faLandmark} className="me-2" />
            MDA Self-Sustaining PVs
          </h4>
          <p className="mb-0 text-muted">
            Manage and generate payment vouchers for self-sustaining MDAs
          </p>
        </div>
        <div className="btn-toolbar mb-2 mb-md-0">
          <Button
            variant="primary"
            size="sm"
            onClick={() =>
              history(Routes.mdaPv.index + "?mda_type=self-sustaining")
            }
            className="me-2"
          >
            <FontAwesomeIcon icon={faPlus} className="me-1" />
            New PV
          </Button>
          <Button
            variant="outline-primary"
            size="sm"
            onClick={refreshData}
            disabled={loading}
          >
            <FontAwesomeIcon
              icon={faSync}
              className={`me-1 ${loading ? "fa-spin" : ""}`}
            />
            Refresh
          </Button>
        </div>
      </div>

      <Card className="mb-4">
        <Card.Header className="d-flex justify-content-between align-items-center">
          <h6 className="mb-0">
            <FontAwesomeIcon icon={faFilter} className="me-2" />
            Filters & Search
          </h6>
          <Button variant="outline-secondary" size="sm" onClick={clearFilters}>
            Clear All
          </Button>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col md={4}>
              <BootstrapForm.Group className="mb-3">
                <BootstrapForm.Label>Search</BootstrapForm.Label>
                <InputGroup>
                  <InputGroup.Text>
                    <FontAwesomeIcon icon={faSearch} />
                  </InputGroup.Text>
                  <BootstrapForm.Control
                    type="text"
                    placeholder="Search PV code, approval no, MDA..."
                    value={filterText}
                    onChange={(e) => setFilterText(e.target.value)}
                  />
                </InputGroup>
              </BootstrapForm.Group>
            </Col>
            <Col md={2}>
              <BootstrapForm.Group className="mb-3">
                <BootstrapForm.Label>Status</BootstrapForm.Label>
                <BootstrapForm.Select
                  value={statusFilter}
                  onChange={(e) => setStatusFilter(e.target.value)}
                >
                  <option value="All">All Statuses</option>
                  {getUniqueStatuses().map((status) => (
                    <option key={status} value={status}>
                      {status}
                    </option>
                  ))}
                </BootstrapForm.Select>
              </BootstrapForm.Group>
            </Col>
            <Col md={2}>
              <BootstrapForm.Group className="mb-3">
                <BootstrapForm.Label>Date From</BootstrapForm.Label>
                <BootstrapForm.Control
                  type="date"
                  value={dateFrom}
                  onChange={(e) => setDateFrom(e.target.value)}
                />
              </BootstrapForm.Group>
            </Col>
            <Col md={2}>
              <BootstrapForm.Group className="mb-3">
                <BootstrapForm.Label>Date To</BootstrapForm.Label>
                <BootstrapForm.Control
                  type="date"
                  value={dateTo}
                  onChange={(e) => setDateTo(e.target.value)}
                />
              </BootstrapForm.Group>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {error && (
        <Alert variant="danger" dismissible onClose={() => setError("")}>
          <FontAwesomeIcon icon={faExclamationTriangle} className="me-2" />
          {error}
        </Alert>
      )}

      <Card border="light" className="table-wrapper table-responsive shadow-sm">
        <Card.Body className="p-0">
          {loading ? (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ height: "300px" }}
            >
              <div className="text-center">
                <Spinner animation="border" variant="primary" />
                <div className="mt-2">Loading data...</div>
              </div>
            </div>
          ) : filteredData.length === 0 ? (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ height: "300px" }}
            >
              <div className="text-center text-muted">
                <FontAwesomeIcon icon={faFileAlt} size="3x" className="mb-3" />
                <h5>No MDA PVs found</h5>
                <p>
                  {filterText || statusFilter !== "All" || dateFrom || dateTo
                    ? "Try adjusting your filters to see more results."
                    : 'Click "New PV" to create the first self-sustaining PV.'}
                </p>
              </div>
            </div>
          ) : (
            <CustomTable fields={fields} data={currentItems} />
          )}
        </Card.Body>

        {totalPages > 1 && (
          <Card.Footer className="px-3 border-0 d-flex align-items-center justify-content-between">
            <small className="fw-bold">
              Showing {indexOfFirstItem + 1} to{" "}
              {Math.min(indexOfLastItem, filteredData.length)} of{" "}
              {filteredData.length} entries
            </small>
            <Pagination className="mb-0">
              <Pagination.Prev
                disabled={currentPage === 1}
                onClick={() => handlePageChange(currentPage - 1)}
              />
              {[...Array(totalPages)].map((_, index) => {
                const pageNumber = index + 1;
                if (
                  pageNumber === 1 ||
                  pageNumber === totalPages ||
                  (pageNumber >= currentPage - 2 &&
                    pageNumber <= currentPage + 2)
                ) {
                  return (
                    <Pagination.Item
                      key={pageNumber}
                      active={pageNumber === currentPage}
                      onClick={() => handlePageChange(pageNumber)}
                    >
                      {pageNumber}
                    </Pagination.Item>
                  );
                } else if (
                  pageNumber === currentPage - 3 ||
                  pageNumber === currentPage + 3
                ) {
                  return <Pagination.Ellipsis key={pageNumber} />;
                }
                return null;
              })}
              <Pagination.Next
                disabled={currentPage === totalPages}
                onClick={() => handlePageChange(currentPage + 1)}
              />
            </Pagination>
          </Card.Footer>
        )}
      </Card>
    </>
  );
}

export default MdaNewPV;
